export const CATEGORY_LAYOUT_REQUEST = 'CATEGORY_LAYOUT_REQUEST';
export const CATEGORY_LAYOUT_CHANGED = 'CATEGORY_LAYOUT_CHANGED';
export const CATEGORY_LAYOUT_FAILED = 'CATEGORY_LAYOUT_FAILED';
export const CATEGORY_NAVIGATION = 'CATEGORY_NAVIGATION';

// Layout Request

export const categoryLayoutRequest = mode => ({
  type: CATEGORY_LAYOUT_REQUEST,
  mode,
});

export const categoryLayoutChanged = mode => ({
  type: CATEGORY_LAYOUT_CHANGED,
  mode,
});

export const categoryLayoutFailed = mode => ({
  type: CATEGORY_LAYOUT_FAILED,
  mode,
});

export default {
  categoryLayoutRequest,
};
